const completionSpec: Fig.Spec = {
	name: "nano",
	description: "Nano's ANOther editor, an enhanced free Pico clone",
	args: {
		template: "filepaths",
	},
};

export default completionSpec;
